import axios from 'axios'

export default class TipoAtuacao {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/dominios/tipoArea`
    this.tokenBearer = tokenBearer
  }

  getTipoArea () {
    return new Promise(async (resolve, reject) => {
      let optionsTipoArea = {
        method: 'get',
        url: `${this.url}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseTipoArea = await axios(optionsTipoArea)
        resolve(responseTipoArea)
      } catch (err) {
        reject(err)
      }
    })
  }
}
